import * as _ from 'lodash';
import { Component, Input, EventEmitter, Output } from '@angular/core';

import { PAGINATION_NUMBER } from '../../../services/constants.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.html'
})
export class PaginationComponent {
  totalPage = 0;

  @Input()
  params: { [key: string]: string | number } = {};

  @Input()
  total = 0;

  @Input()
  page = 1;

  @Output()
  goTo: EventEmitter<number> = new EventEmitter<number>();

  totalPages() {
    return Math.ceil(this.total / PAGINATION_NUMBER);
  }

  rangeStart() {
    return Math.floor(this.page / 10) * 10 + 1;
  }

  pagesRange() {
    return _.range(this.rangeStart(), Math.min(this.rangeStart() + 10, this.totalPages() + 1));
  }

  prevPage() {
    return Math.max(1, this.rangeStart() - 10);
  }

  nextPage() {
    return Math.min(this.totalPages(), this.rangeStart() + 10);
  }

  pageParams(page: number) {
    const params = _.clone(this.params);
    params['page'] = page;
    return params;
  }

  @Log('blue')
  pageClicked(page: number) {
    this.goTo.next(page);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/core/pagination/pagination.component.ts